import {
  Intersection,
  Object3D,
  Raycaster,
  Vector2,
} from 'three';

import type { ScatterCamera } from '../ScatterCamera';
const raycaster = new Raycaster();
const objects: Object3D[] = [];
const mouse = new Vector2( 1, 1 );

// the array of intersections sorted by distance
let intersections: Intersection[] = [];

document.addEventListener('mousemove', onMouseMove );
function onMouseMove(event: MouseEvent) {
  // event.preventDefault();

  mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
  mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
}

export function registerObject(obj: Object3D) {
  const notYetRegistered = !objects.find((registeredObject) => obj === registeredObject);
  if (notYetRegistered) objects.push(obj);
}

// note: not tested yet
export function deregisterObject(obj: Object3D) {
  const index = objects.findIndex((registeredObject) => obj === registeredObject);
  if (index !== -1) objects.splice(index, 1)
}

function intersectionSort(intersectionA: Intersection, intersectionB: Intersection): number {
  return intersectionA.distance - intersectionB.distance;
}
// adds an intersection to "intersections"
// if it intersects with the mouse position
export function updateRaycaster(camera: ScatterCamera): Raycaster {
  if (camera.isTransitioning()) {
    intersections = [];
    return raycaster;
  }

  raycaster.setFromCamera(mouse, camera);

  const newIntersections: Intersection[] = [];

  objects.forEach((object) => {
    const objectIntersections: Intersection[] = raycaster.intersectObject(object, true);

    if (objectIntersections.length) {
      newIntersections.push(objectIntersections[0]);
    }
  });

  newIntersections.sort(intersectionSort);
  intersections = newIntersections;
  return raycaster;
}

export {
  intersections,
};
